import { render, staticRenderFns } from "./calc-selector-page.vue?vue&type=template&id=6cdae6ef&"
import script from "./calc-selector-page.vue?vue&type=script&lang=ts&"
export * from "./calc-selector-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cdae6ef')) {
      api.createRecord('6cdae6ef', component.options)
    } else {
      api.reload('6cdae6ef', component.options)
    }
    module.hot.accept("./calc-selector-page.vue?vue&type=template&id=6cdae6ef&", function () {
      api.rerender('6cdae6ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calc-selector-page/calc-selector-page.vue"
export default component.exports